import { TreatmentType } from "@keita/lanepatrol-sdk";
import { t } from "i18next";

export const getTreatmentLabel = (treatmentType: TreatmentType) =>
  t(`sdk:treatments.${treatmentType}`);
